import repo from 'service/repository';
import { PATH } from 'config';

const welcomeList = ['intro', 'parkinglots'];

const onBoardingAddPlateNumberData = {
  promises: [repo.fetchUserInfo, repo.fetchLicensePlates, repo.fetchBootstraps],
  path: PATH.USER_BIND_NPC_CARD,
};

const mainFeaturesList = ['parking'];

const bottomTabList = ['main', 'maps', 'orders'];

const ordersList = [{ key: 'parking', value: '停車場' }];

const configData = {
  welcomeList,
  onBoardingAddPlateNumberData,
  mainFeaturesList,
  bottomTabList,
  ordersList,
};

export default configData;
